/* SABERA: 共通検索フォームのクリアボタン制御。
   入力があるときだけ ✕ を出し、押すと空にしてフォーカスを戻す。Esc でも同じ。
   フォームの送信自体は素の GET なので、この JS が無くても検索は動く。 */
(function () {
  'use strict';

  function init(form) {
    var input = form.querySelector('.sabera-search-form__input');
    var clear = form.querySelector('[data-sabera-search-clear]');
    if (!input || !clear) return;

    function sync() {
      clear.hidden = input.value.length === 0;
    }

    function reset() {
      input.value = '';
      sync();
      input.focus();
      // 検索結果ページ側が入力の変化を拾えるようにする
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }

    input.addEventListener('input', sync);
    clear.addEventListener('click', reset);
    input.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || input.value.length === 0) return;
      // type="search" のネイティブ Esc (Chrome) と二重で効かないよう既定動作を止める
      event.preventDefault();
      reset();
    });

    sync();
  }

  function initAll() {
    document.querySelectorAll('[data-sabera-search-form]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
